import * as yup from "yup";

import { FormId } from "../../../../../components/enums";
import { textareaValidatorRequired } from "../../../../../utilities/validators";

import { ComponentId } from "./enums";

export const validator = {
  [FormId.DAMAGES_IMAGES_DESCRIPTION]: yup.object({
    [ComponentId.DESCRIPTION]: textareaValidatorRequired(1000),
  }),
};
